import { defineMessages } from "react-intl";

export const aiAssistantMessages = defineMessages({
    windowTitle: {
        id: "aiAssistant.window.title",
        defaultMessage: "AI asistent",
    },
    inputPlaceholder: {
        id: "aiAssistant.input.placeholder",
        defaultMessage: "Napište zprávu…",
    },
    send: {
        id: "aiAssistant.action.send",
        defaultMessage: "Odeslat",
    },
    cancel: {
        id: "aiAssistant.action.cancel",
        defaultMessage: "Zrušit",
    },
    stop: {
        id: "aiAssistant.action.stop",
        defaultMessage: "Zastavit",
    },
    branchCheck: {
        id: "aiAssistant.action.branchCheck",
        defaultMessage: "Kontrola větve",
    },
    branchTitle: {
        id: "aiAssistant.branch.title",
        defaultMessage: "Kontrola větve",
    },
    branchConfirm: {
        id: "aiAssistant.branch.confirm",
        defaultMessage: "Větev pod vybranou jednotkou popisu má {levels, plural, one {# podřízenou úroveň} few {# podřízené úrovně} other {# podřízených úrovní}}. Kontrola je stáhne a projde po oknech v jednom běhu; kdykoli ji můžete zastavit. Spustit?",
    },
    branchEmpty: {
        id: "aiAssistant.branch.empty",
        defaultMessage: "Vybraná jednotka popisu nemá žádné podřízené úrovně.",
    },
    branchLoadFailed: {
        id: "aiAssistant.branch.loadFailed",
        defaultMessage: "Velikost větve se nepodařilo zjistit.",
    },
    branchStart: {
        id: "aiAssistant.branch.start",
        defaultMessage: "Spustit",
    },
    copy: {
        id: "aiAssistant.action.copy",
        defaultMessage: "Kopírovat",
    },
    copied: {
        id: "aiAssistant.action.copied",
        defaultMessage: "Zkopírováno",
    },
    conversationMenu: {
        id: "aiAssistant.action.conversationMenu",
        defaultMessage: "Možnosti konverzace",
    },
    rename: {
        id: "aiAssistant.action.rename",
        defaultMessage: "Přejmenovat",
    },
    renameTitle: {
        id: "aiAssistant.rename.title",
        defaultMessage: "Přejmenovat konverzaci",
    },
    renameLabel: {
        id: "aiAssistant.rename.label",
        defaultMessage: "Název",
    },
    save: {
        id: "aiAssistant.action.save",
        defaultMessage: "Uložit",
    },
    delete: {
        id: "aiAssistant.action.delete",
        defaultMessage: "Smazat",
    },
    deleteTitle: {
        id: "aiAssistant.delete.title",
        defaultMessage: "Smazat konverzaci",
    },
    deleteConfirm: {
        id: "aiAssistant.delete.confirm",
        defaultMessage: "Konverzace „{title}“ bude smazána včetně všech odpovědí. Pokračovat?",
    },
    taskNeedsNode: {
        id: "aiAssistant.task.needsNode",
        defaultMessage: "Vyžaduje otevřenou jednotku popisu",
    },
    taskNeedsEntity: {
        id: "aiAssistant.task.needsEntity",
        defaultMessage: "Vyžaduje otevřenou archivní entitu",
    },
    taskNeedsNodeOrEntity: {
        id: "aiAssistant.task.needsNodeOrEntity",
        defaultMessage: "Vyžaduje otevřenou jednotku popisu nebo archivní entitu",
    },
    taskNeedsFund: {
        id: "aiAssistant.task.needsFund",
        defaultMessage: "Vyžaduje otevřený archivní soubor",
    },
    taskNeedsContext: {
        id: "aiAssistant.task.needsContext",
        defaultMessage: "Není dostupné v aktuálním kontextu",
    },
    empty: {
        id: "aiAssistant.state.empty",
        defaultMessage: "Zeptejte se AI asistenta na cokoli.",
    },
    thinking: {
        id: "aiAssistant.state.thinking",
        defaultMessage: "AI přemýšlí…",
    },
    usage: {
        id: "aiAssistant.usage.summary",
        defaultMessage: "Využití",
    },
    usageTokens: {
        id: "aiAssistant.usage.tokens",
        defaultMessage: "Vstupní tokeny: {input}, výstupní tokeny: {output}",
    },
    usagePrice: {
        id: "aiAssistant.usage.price",
        defaultMessage: "Cena: {credits} kr.",
    },
    usageProfile: {
        id: "aiAssistant.usage.profile",
        defaultMessage: "Model: {profile}",
    },
    usageStarted: {
        id: "aiAssistant.usage.started",
        defaultMessage: "Zahájeno: {datetime}",
    },
    usageDuration: {
        id: "aiAssistant.usage.duration",
        defaultMessage: "Doba zpracování: {duration}",
    },
    usageMenuItem: {
        id: "aiAssistant.usage.menuItem",
        defaultMessage: "Využití",
    },
    usageDialogTitle: {
        id: "aiAssistant.usage.dialog.title",
        defaultMessage: "Využití",
    },
    usageDialogClose: {
        id: "aiAssistant.usage.dialog.close",
        defaultMessage: "Zavřít",
    },
    usageNoData: {
        id: "aiAssistant.usage.noData",
        defaultMessage: "Informace o spotřebě nejsou pro tohoto poskytovatele k dispozici.",
    },
    usageAccountHeading: {
        id: "aiAssistant.usage.accountHeading",
        defaultMessage: "Váš účet",
    },
    usageSharedAccountHeading: {
        id: "aiAssistant.usage.sharedAccountHeading",
        defaultMessage: "Sdílený účet organizace",
    },
    usageCustomerHeading: {
        id: "aiAssistant.usage.customerHeading",
        defaultMessage: "Rozpočet organizace",
    },
    balanceUsedPercent: {
        id: "aiAssistant.balance.usedPercent",
        defaultMessage: "Vyčerpáno {percent} %",
    },
    balanceWeeklyUsedPercent: {
        id: "aiAssistant.balance.weeklyUsedPercent",
        defaultMessage: "Tento týden vyčerpáno {percent} %",
    },
    balanceUnlimited: {
        id: "aiAssistant.balance.unlimited",
        defaultMessage: "Bez limitu",
    },
    balancePlan: {
        id: "aiAssistant.balance.plan",
        defaultMessage: "Tarif: {plan}",
    },
    balanceResets: {
        id: "aiAssistant.balance.resets",
        defaultMessage: "Obnoví se {date} ({days, plural, one {za 1 den} few {za # dny} other {za # dní}})",
    },
    errorNoSubscription: {
        id: "aiAssistant.error.noSubscription",
        defaultMessage: "AI služba nemá aktivní předplatné. Obraťte se na správce.",
    },
    errorQuotaExceeded: {
        id: "aiAssistant.error.quotaExceeded",
        defaultMessage: "Měsíční rozpočet organizace pro AI služby je vyčerpán.",
    },
    errorAccountQuotaExceeded: {
        id: "aiAssistant.error.accountQuotaExceeded",
        defaultMessage: "Váš kreditový limit je pro toto období vyčerpán.",
    },
    unsupportedBlock: {
        id: "aiAssistant.block.unsupported",
        defaultMessage: "Nepodporovaný typ obsahu.",
    },
    citations: {
        id: "aiAssistant.block.citations",
        defaultMessage: "Zdroje",
    },
    recordCitations: {
        id: "aiAssistant.block.recordCitations",
        defaultMessage: "Záznamy",
    },
    errorPrefix: {
        id: "aiAssistant.state.errorPrefix",
        defaultMessage: "Chyba",
    },
    contextNone: {
        id: "aiAssistant.context.none",
        defaultMessage: "Bez kontextu",
    },
    contextPromptLabel: {
        id: "aiAssistant.context.promptLabel",
        defaultMessage: "Kontext:",
    },
    settings: {
        id: "aiAssistant.action.settings",
        defaultMessage: "Nastavení",
    },
    profile: {
        id: "aiAssistant.action.profile",
        defaultMessage: "Model",
    },
    profileDefault: {
        id: "aiAssistant.profile.default",
        defaultMessage: "Výchozí",
    },
    fullWidthResponses: {
        id: "aiAssistant.settings.fullWidthResponses",
        defaultMessage: "Odpovědi na celou šířku",
    },
    newChat: {
        id: "aiAssistant.action.newChat",
        defaultMessage: "Nová konverzace",
    },
    history: {
        id: "aiAssistant.action.history",
        defaultMessage: "Historie konverzací",
    },
    expandPanel: {
        id: "aiAssistant.action.expandPanel",
        defaultMessage: "Rozbalit panel",
    },
    collapsePanel: {
        id: "aiAssistant.action.collapsePanel",
        defaultMessage: "Sbalit panel",
    },
    contextModule: {
        id: "aiAssistant.context.module",
        defaultMessage: "Modul",
    },
    moduleArrangement: {
        id: "aiAssistant.context.module.arrangement",
        defaultMessage: "Pořádání",
    },
    moduleRegistry: {
        id: "aiAssistant.context.module.registry",
        defaultMessage: "Entity",
    },
    contextFund: {
        id: "aiAssistant.context.fund",
        defaultMessage: "Archivní soubor",
    },
    contextNode: {
        id: "aiAssistant.context.node",
        defaultMessage: "Jednotka popisu",
    },
    contextAccessPoint: {
        id: "aiAssistant.context.accessPoint",
        defaultMessage: "Přístupový bod",
    },
    steps: {
        id: "aiAssistant.activity.steps",
        defaultMessage: "Postup zpracování",
    },
    activityToolSearchNodes: {
        id: "aiAssistant.activity.tool.searchNodes",
        defaultMessage: "Vyhledávání v archivním popisu",
    },
    activityToolGetItemTypes: {
        id: "aiAssistant.activity.tool.getItemTypes",
        defaultMessage: "Načtení typů prvků popisu",
    },
    activityToolSearchKnowledge: {
        id: "aiAssistant.activity.tool.searchKnowledge",
        defaultMessage: "Vyhledávání v poradně",
    },
    activityToolGetSection: {
        id: "aiAssistant.activity.tool.getSection",
        defaultMessage: "Čtení dokumentace",
    },
    activityToolGeneric: {
        id: "aiAssistant.activity.tool.generic",
        defaultMessage: "Nástroj {tool}",
    },
    activityPreparation: {
        id: "aiAssistant.activity.preparation",
        defaultMessage: "Příprava zpracování",
    },
    activityStepGeneric: {
        id: "aiAssistant.activity.step.generic",
        defaultMessage: "Krok zpracování",
    },
    activityResultCount: {
        id: "aiAssistant.activity.resultCount",
        defaultMessage: "{count, plural, one {# výsledek} few {# výsledky} other {# výsledků}}",
    },
    activityResultPartial: {
        id: "aiAssistant.activity.resultPartial",
        defaultMessage: "výsledek zkrácen",
    },
    activityMoreLinks: {
        id: "aiAssistant.activity.moreLinks",
        defaultMessage: "{count, plural, one {+# další} few {+# další} other {+# dalších}}",
    },
    activityLinkOpen: {
        id: "aiAssistant.activity.linkOpen",
        defaultMessage: "Zobrazit záznam",
    },
    proposalApply: {
        id: "aiAssistant.proposal.apply",
        defaultMessage: "Použít",
    },
    proposalReject: {
        id: "aiAssistant.proposal.reject",
        defaultMessage: "Odmítnout",
    },
    proposalClarify: {
        id: "aiAssistant.proposal.clarify",
        defaultMessage: "Upřesnit…",
    },
    proposalApplied: {
        id: "aiAssistant.proposal.applied",
        defaultMessage: "Použito",
    },
    proposalRejected: {
        id: "aiAssistant.proposal.rejected",
        defaultMessage: "Odmítnuto",
    },
    proposalSuperseded: {
        id: "aiAssistant.proposal.superseded",
        defaultMessage: "Nahrazeno novějším návrhem",
    },
    proposalActionFailed: {
        id: "aiAssistant.proposal.actionFailed",
        defaultMessage: "Akci se nepodařilo provést: {error}",
    },
});

export const aiContextSegmentLabels = {
    module: aiAssistantMessages.contextModule,
    fund: aiAssistantMessages.contextFund,
    node: aiAssistantMessages.contextNode,
    accessPoint: aiAssistantMessages.contextAccessPoint,
};

export const aiModuleLabels = {
    arrangement: aiAssistantMessages.moduleArrangement,
    registry: aiAssistantMessages.moduleRegistry,
};
